import { digitsEnToFa, digitsFaToEn } from "persian-tools2";
import jMoment from 'jalali-moment';
import persianDate from "persian-date";
import moment from "moment";

const recognizePublishMode = (string) => {
    switch (string) {
        case 'development':
            return {name: 'DEVELOPMENT', url: 'https://dev.srv.farirdev.ir'};
        case 'production':
            return {name: 'PRODUCTION', url: 'https://freesens.app:8001'};
        case 'release':
            return { name: 'RELEASE', url: 'https://release.srv.farirdev.ir'};
        default:
            return null
    }
};

export const PUBLISH_MODE = recognizePublishMode(process.env.REACT_APP_PUBLISH_MODE);

export const PRODUCTION_MODE = process.env.REACT_APP_PUBLISH_MODE === 'production' ? true : false;

export const addEventListener = (type, func) => {
    //for android listener
    document.addEventListener(type, func);
    //for ios listener
    window.addEventListener(type, func);
};
export const removeEventListener = (type, func) => {
    document.removeEventListener(type, func);
    window.removeEventListener(type, func);
};

export const patientPregnancyType = (type) => {
    return type === true
        ? 'باردار است'
        : type ===false?'باردار نیست':'';
};

export const validateMobileNumber = (value) => {
    let error;
    const num = digitsFaToEn(value);
    if (!/^(09)\d{9}$/i.test(num)) {
        error = 'شماره تلفن باید با ۰۹ شروع شود و ۱۱ رقم باشد ';
    }

    return error;
};

export const patientDiabetType = (type) => {
    const diabetType =
        type === 0
            ? 'دیابت نوع یک'
            : type === 1
                ? 'دیابت نوع دو'
                : type === 2
                    ? 'دیابت بارداری'
                    : type === 4
                        ? 'پیش دیابت'
                        : type === 3
                            ? 'نامشخص'
                            : '';
    return diabetType;
};

export const patientInsulinType = (type) => {
    return type === 1
        ? '2 مرتبه در روز یا کمتر'
        : type === 2
            ? '3 مرتبه در روز یا بیشتر'
            : type === 0
                ? 'خیر'
                : '';
};

export const validateName = (value, field) => {
    let error = null;
    let p = /^[\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC\u0629\u0643\u0649-\u064B\u064D\u06D5\s ]+$/;
    if (!value) {
        error = `لطفا ${field} خود را وارد کنید`;
    } else if (!p.test(value)) {
        error = `${field} خود را فارسی وارد کنید`;
    }
    return error;
};


export const year = () => {
    let years = [];
    const thisYear =moment().locale('fa').format('YYYY')
    for (let i = 1300; i <= thisYear; i++) {
        years.push({ value: i.toString(), id: i.toString() });
    }
    return years;
};

export const convertIsoToPersian = (value) => {
    let options = { month: 'long', day: 'numeric' };
    let date = new Date(value).toLocaleDateString('fa-IR', options);
    return date;
};


export const convertDate = (value) => {
    let moment = jMoment(value, 'jYYYY/jM/jD'); /*e.g => 1400/03/04 */
    moment.locale('fa');
    // const year = moment.jYear();        /* e.g => yearDigit = 1400 */
    // const month = moment.jMonth() + 1; /*e.g => monthnDigit = 10  */
    // const day = moment.jDate();       /* e.g => day = 16 */
    const fullDateLong = moment.format('dddd jD jMMMM'); /* شنبه 5 مهر */

    return {
        //  year, month, day, 
        fullDateLong
    };
};

export const formatingInitialValue = (value) => {
    let moment = jMoment(digitsFaToEn(value), 'jYYYY/jM/jD');
    const year = moment.jYear();
    const month = moment.jMonth() + 1;
    const day = moment.jDate();
    return { year, month, day };
};

export const whatsappUrl = 'https://wa.link/zatrmp';
export const rayChatUrl = 'https://widget.raychat.io/64e4741d9d5ee8c0bd2f3bb2?version=2'
export const validateSharePhoneNumber = (value) => {
    let error;
    const num = digitsFaToEn(value);
    if (!/^(09)\d{9}$/i.test(num)) {
        error = '*شماره تلفن باید با 09 شروع شود و 11 رقم باشد.';
    }
    return error;
};

export const options = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
};
export const timeOptions = {
    hourCycle: 'h24',
    hour: '2-digit',
    minute: '2-digit',
};
export const time12hOptions = {
    hourCycle: 'h12',
    hour: '2-digit',
    minute: '2-digit',
};

export const yearOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
};
export const destructureDataForModalCards = (cardData) => {
    const id = cardData?.id;
    let weekday, dateNumeric, time;
    if (cardData?.dateNumeric) {
        weekday = cardData?.dateNumeric?.fullDateLong;
        dateNumeric = digitsEnToFa(cardData?.dateNumeric?.numericDate);
        time = cardData?.time;
    } else {
        const timestamp = new Date(cardData?.estimatedDate);
        // year date 1400/1/1
        dateNumeric = new Intl.DateTimeFormat('fa-IR', yearOptions).format(
            timestamp
        );
        // hour
        time = new Intl.DateTimeFormat('fa-IR', timeOptions).format(
            timestamp
        );
        // weekday   => دوشنبه 5 مهر
        weekday = new Intl.DateTimeFormat('fa-IR', options).format(
            timestamp
        );
    }

    // suger result
    const testResult = cardData?.testResult;
    // mealStatus => postmeal/premeal/unknown
    const mealStatus = cardData?.mealStatus;
    // glocouse status => high/ inRange / Low
    const glucoseStatus = cardData?.glucoseStatus;
    const description = cardData?.description;
    const timeStatus = cardData?.timeStatus;
    const actualDate = cardData?.actualDate;
    const estimatedDate = cardData?.estimatedDate;
    const jalaliDate = cardData?.jalaliDate;
    const tags = cardData?.tags;

    return { id, testResult, glucoseStatus, tags, description, timeStatus, mealStatus, jalaliDate, actualDate, estimatedDate, dateNumeric, time, weekday };

};

export const daysArray = () => {
    const days = [];

    for (let i = 1; i < 32; i++) {
        days.push({ id: i.toString(), value: digitsEnToFa(i.toString()) });
    }
    return days;
};
// output is دوشنبه 12تیر 1402
export const datePersianFormat = (jalaliDate) => {
    const dateValue = jalaliDate.split(/\s+/)[0].split("/");
    let dateFormat = new persianDate([parseInt(dateValue[0]), parseInt(dateValue[1]), parseInt(dateValue[2])]);
    return dateFormat.format('dddd') + ' ' + dateValue[2] + ' ' + dateFormat.format('MMMM') + ' ' + dateValue[0];
};

function areStringsEqual(str1, str2) {
    if (str1?.length !== str2?.length) {
        return false; // Different lengths, can't be equal
    }
    for (let i = 0; i < str1?.length; i++) {
        if (str1[i] !== str2[i]) {
            return false; // Found a character that is different
        }
    }
    return true; // All characters are equal
}

export {areStringsEqual};
